import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './index.css';

export interface IAdditionalFeatureItemProps {
  className?: string;
  name: string;
  value: string | number | undefined;
}

export class AdditionalFeatureItem extends React.PureComponent<IAdditionalFeatureItemProps, {}> {
  public render() {
    const {
      className,
      name,
      value,
    } = this.props;

    if (!value) {
      return null;
    }

    return (
      <li {...mergeStyles([styles['item'], className])}>
        <span className={styles['name']}>{name}</span>
        <span className={styles['value']}>{value}</span>
      </li>
    );
  }
}
